import {Typography, TypographyProps} from './Typography'

export const BodyMedium = ({...props}: Omit<TypographyProps, 'variant'>) => {
    return <Typography variant="body-medium" {...props}/>
}